/**
 * Pastel busy-event colors per interviewer (parity with KInterviewScheduler pastel pool).
 * Uses design-system CSS variables — see `calendar.css` / `eventStyles.ts`.
 */
import {
  getScheduleInterviewerPastelKey,
  pastelNumberFromKey,
  syncScheduleInterviewerPastelKeys,
} from '../state/interviewerPastelMap';

export interface PastelSlotColors {
  backgroundColor: string;
  borderColor: string;
  textColor: string;
}

export function getPastelSlotColorsForUser(
  sortedInterviewerIds: number[],
  userId?: number
): PastelSlotColors {
  syncScheduleInterviewerPastelKeys(sortedInterviewerIds);
  const sorted = [...new Set(sortedInterviewerIds)]
    .filter((id) => Number.isFinite(id) && id > 0)
    .sort((a, b) => a - b);
  const uid =
    typeof userId === 'number' &&
    Number.isFinite(userId) &&
    sorted.includes(userId)
      ? userId
      : sorted[0];
  const key = getScheduleInterviewerPastelKey(uid ?? 0);
  const n = pastelNumberFromKey(key);
  return {
    backgroundColor: `var(--kula-colors-pastel-${n}-light)`,
    borderColor: `var(--kula-colors-pastel-${n})`,
    textColor: `var(--kula-colors-pastel-${n}-dark)`,
  };
}
